import React, { useState, useEffect } from 'react';
import { projectGroups } from '../data/projects';

function Lightbox({ src, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  if (!src) return null;
  return (
    <div className="lightbox" onClick={onClose} role="dialog" aria-modal="true">
      <button className="lightbox-close" onClick={onClose} aria-label="Fermer">×</button>
      <img src={src} alt="" onClick={(e) => e.stopPropagation()} />
    </div>
  );
}

export default function Projets({ navigate }) {
  const [activeGroup, setActiveGroup] = useState(projectGroups[0].id);
  const [lightboxSrc, setLightboxSrc] = useState(null);

  const current = projectGroups.find((g) => g.id === activeGroup) || projectGroups[0];

  return (
    <article className="projets-page">
      <header className="projets-hero">
        <div className="projets-hero-overlay">
          <p className="projets-eyebrow">Projets antérieurs</p>
          <h1 className="projets-title">Quarante ans de réalisations</h1>
          <p className="projets-lede">
            Au fil des campagnes, l’association a construit puits, dispensaires et écoles
            dans plusieurs villages du Togo, du Bénin et des pays voisins.
          </p>
        </div>
      </header>

      <nav className="projets-tabs" aria-label="Régions">
        <div className="projets-tabs-inner">
          {projectGroups.map((g) => (
            <button
              key={g.id}
              type="button"
              className={`projets-tab ${activeGroup === g.id ? 'projets-tab-active' : ''}`}
              onClick={() => setActiveGroup(g.id)}
            >
              {g.title}
            </button>
          ))}
        </div>
      </nav>

      <section className="projets-section">
        <div className="projets-inner">
          <h2 className="projets-section-title">{current.title}</h2>
          {current.subtitle && <p className="projets-section-subtitle">{current.subtitle}</p>}

          {current.projects.map((project) => (
            <section key={project.id} className="project-block">
              <header className="project-header">
                <h3>{project.title}</h3>
                {project.text && <p>{project.text}</p>}
              </header>
              <div className="project-gallery">
                {project.photos.map((photo, i) => (
                  <button
                    key={i}
                    type="button"
                    className="project-photo"
                    onClick={() => setLightboxSrc(photo.src)}
                  >
                    <img src={photo.src} alt={photo.alt || project.title} loading="lazy" />
                  </button>
                ))}
              </div>
            </section>
          ))}

          <div className="projets-cta">
            <button type="button" className="link-button" onClick={() => navigate('historique')}>
              Lire l’histoire de l’association →
            </button>
            <button type="button" className="link-button" onClick={() => navigate('home')}>
              ← Retour à l’accueil
            </button>
          </div>
        </div>
      </section>

      <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />
    </article>
  );
}
